const DOMAIN = window.location.hostname !== "localhost" ? window.location.origin: 'http://dev-stampfli.ch.stampfliag02.nine.ch';
const HOTEL_SELECTION = 64407315;

export { DOMAIN, HOTEL_SELECTION };